<div
  id="journal-chart-container"
  class="component-container"
>
  <div
    *ngIf="printData?.userName"
    class="heading"
  >
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    class="heading flex xs:flex-col sm:flex-row md:flex-row justify-between items-center"
  >
    <div class="title">
      {{ !memberId ? "My " : "" }}Journal
      <span class="additional-text">{{ additionalText }}</span>
    </div>
    <div class="controls flex flex-row justify-between items-center">
      <mat-checkbox
        *ngFor="let item of legendList"
        [style]="{ '--checkbox-color': item.color }"
        [checked]="item.checked"
        [disabled]="chartTableData?.loading"
        (change)="onRoleToggle(item)"
      >
        {{ item.label }}
      </mat-checkbox>
    </div>
  </div>
  <div
    class="chart-container flex-row flex w-full xs:h-[50rem] sm:h-[50rem] md:h-[50rem]"
  >
    <div
      *ngIf="chartData?.loading"
      class="chart-loader w-full h-full flex justify-center items-center"
    >
      <mat-spinner
        strokeWidth="5"
        [diameter]="60"
      />
    </div>
    <grouped-bar-chart-two
      *ngIf="chartData?.data"
      chartName="journaling"
      [chartData]="chartData.data"
      [yAxisLabel]="'Days Journaled'"
      [xAxisLabel]="'Weeks'"
      class="w-full"
    ></grouped-bar-chart-two>
    <div
      *ngIf="!chartData?.loading && !chartData?.data"
      class="no-chart-data w-full h-full flex justify-center items-center"
    >
      No data to show on chart.
    </div>
  </div>
  <div class="table-container w-full">
    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div
        class="table-wrapper table-container xs:w-[80rem] sm:w-[80rem] md:w-full {{
          printData
            ? ''
            : 'xs:max-h-[85vh] sm:max-h-[85vh] md:max-h-[calc(90vh-6rem)] xl:max-h-[calc(95vh-6rem)] overflow-auto'
        }}"
        infiniteScroll
        (scrolled)="onScroll()"
        [fromRoot]="true"
        [immediateCheck]="true"
        [infiniteScrollDisabled]="!chartData?.data"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
      >
        <table
          *ngIf="chartTableData?.data?.list?.length"
          mat-table
          [dataSource]="chartTableData?.data?.list"
          class="journal-table"
        >
          <ng-container matColumnDef="week">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-center pl-3 w-[10%] sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Week
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              mat-cell
              class="text-center pl-3 w-[10%]"
              *matCellDef="let element"
            >
              {{ element.weekNumber || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateRange">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-center pl-3  w-[20%] sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Date Range
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              mat-cell
              class="text-center pl-3 w-[20%]"
              *matCellDef="let element"
            >
              {{ element.dateRange.start | date: "MMM dd, yyyy" }} -
              {{ element.dateRange.end | date: "MMM dd, yyyy" }}
            </td>
          </ng-container>

<!--          <ng-container matColumnDef="sessions">-->
<!--            <th-->
<!--              mat-header-cell-->
<!--              class="w-[14%]"-->
<!--              *matHeaderCellDef-->
<!--            >-->
<!--              Session-->
<!--            </th>-->
<!--            <td-->
<!--              style="-->
<!--                min-width: 12rem;-->
<!--                max-width: 18rem;-->
<!--                overflow: visible;-->
<!--                white-space: nowrap;-->
<!--              "-->
<!--              class="sessions-cell w-[14%]"-->
<!--              mat-cell-->
<!--              *matCellDef="let element"-->
<!--            >-->
<!--              <ng-container *ngIf="element.sessions?.length; else noSessions">-->
<!--                <div-->
<!--                  *ngFor="let session of element.sessions"-->
<!--                  class="td-cell session flex flex-col gap-[1rem]"-->
<!--                >-->
<!--                  <div-->
<!--                    *ngIf="session['sessionNumber']"-->
<!--                    class="session flex flex-row justify-start items-center gap-x-[1rem]"-->
<!--                  >-->
<!--                    <span class="pill-container">-->
<!--                      S{{ session.sessionNumber | number: "2.0-0" }}-->
<!--                    </span>-->
<!--                    <span class="session-date">-->
<!--                      {{ session.date | date: "MMM dd" }}-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </ng-container>-->
<!--              <ng-template #noSessions>-->
<!--                <span>-</span>-->
<!--              </ng-template>-->
<!--            </td>-->
<!--          </ng-container>-->

          <ng-container matColumnDef="noOfDays">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="pl-3 text-center w-[14%]"
            >
              Days Journaled <br />
              Any Behavior
            </th>
            <td
              mat-cell
              class="pl-3 text-center w-[14%]"
              *matCellDef="let element"
            >
              {{ element.noOfDays || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="rlTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="pl-3 text-center w-[14%]"
              >Days Journaled <br />
              Red Light Foods
            </th>
            <td
              mat-cell
              class="pl-3 text-center w-[14%]"
              *matCellDef="let element"
            >
              {{ element.rlTotal || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="paTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="pl-3 text-center w-[14%]"
            >
              Days Journaled <br />
              Physical Activity
            </th>
            <td
              class="pl-3 text-center w-[14%]"
              mat-cell
              *matCellDef="let element"
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span>{{ element.paTotal || "-" }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="stTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="pl-3 text-center w-[14%]"
            >
              Days Journaled <br />
              Screen Time
            </th>
            <td
              class="pl-3 text-center w-[14%]"
              mat-cell
              *matCellDef="let element"
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span>{{ element.stTotal || "-" }}</span>
              </div>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columns"
          ></tr>
          <tr
            class="mat-row"
            *matNoDataRow
          >
            <td
              class="mat-cell"
              [colSpan]="columns.length"
            >
              No data found.
            </td>
          </tr>
        </table>

        <div
          *ngIf="chartData?.data && chartTableData?.loading"
          class="chart-table-loader w-full h-[10rem] flex justify-center items-center"
        >
          <mat-spinner
            strokeWidth="5"
            [diameter]="60"
          />
        </div>
      </div>
    </div>
  </div>
</div>
